import { z } from 'zod';

const dispenseItemSchema = z.object({
  medicineId: z.string().min(1, 'Medicine is required'),
  batchNo: z.string().min(1, 'Batch number is required'),
  qty: z.number().min(1, 'Quantity must be greater than 0'),
  unitPrice: z.number().min(0, 'Unit price must be 0 or greater'),
  mrp: z.number().min(0, 'MRP must be 0 or greater').optional(),
});

export const dispenseSchema = z.object({
  patientId: z.string().min(1, 'Patient is required'),
  prescriptionId: z.string().optional(),
  doctorId: z.string().optional(),
  admissionId: z.string().optional(),
  items: z.array(dispenseItemSchema).min(1, 'At least one item is required'),
  paymentStatus: z.enum(['paid', 'unpaid']),
  notes: z.string().optional(),
});

export type DispenseFormData = z.infer<typeof dispenseSchema>;
export type DispenseItemFormData = z.infer<typeof dispenseItemSchema>;
